/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeatureTileOrderUpdate } from './FeatureTileOrderUpdate';
import {
    FeatureTileOrderUpdateFromJSON,
    FeatureTileOrderUpdateFromJSONTyped,
    FeatureTileOrderUpdateToJSON,
    FeatureTileOrderUpdateToJSONTyped,
} from './FeatureTileOrderUpdate';

/**
 * 
 * @export
 * @interface FeatureTilesReorderRequest
 */
export interface FeatureTilesReorderRequest {
    /**
     * 
     * @type {Array<FeatureTileOrderUpdate>}
     * @memberof FeatureTilesReorderRequest
     */
    tileOrders: Array<FeatureTileOrderUpdate>;
}

/**
 * Check if a given object implements the FeatureTilesReorderRequest interface.
 */
export function instanceOfFeatureTilesReorderRequest(value: object): value is FeatureTilesReorderRequest {
    if (!('tileOrders' in value) || value['tileOrders'] === undefined) return false;
    return true;
}

export function FeatureTilesReorderRequestFromJSON(json: any): FeatureTilesReorderRequest {
    return FeatureTilesReorderRequestFromJSONTyped(json, false);
}

export function FeatureTilesReorderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureTilesReorderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tileOrders': ((json['tileOrders'] as Array<any>).map(FeatureTileOrderUpdateFromJSON)),
    };
}

export function FeatureTilesReorderRequestToJSON(json: any): FeatureTilesReorderRequest {
    return FeatureTilesReorderRequestToJSONTyped(json, false);
}

export function FeatureTilesReorderRequestToJSONTyped(value?: FeatureTilesReorderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tileOrders': ((value['tileOrders'] as Array<any>).map(FeatureTileOrderUpdateToJSON)),
    };
}

